import blogs from "../../data/blogs.json";

export const initialState = [...blogs];
